module.exports = __webpack_public_path__ + "static/media/iko-logo.e48beb2a.png";